import React from 'react';
import { useTranslation } from 'react-i18next';

type MenuItemAllergensProps = {
  items: string[];
  className?: string;
};

const AllergensList = (props: MenuItemAllergensProps) => {
  const { items, className } = props;
  const { t } = useTranslation(null, { keyPrefix: 'Shared:Allergens' });

  return (
    <>
      <div className={className}>
        <h6 className="w-full bg-gray-500 lg:px-lg px-md py-xs">{t('title')}</h6>
        <ul className="lg:px-lg px-md py-md text-sm text-gray-700 list-disc list-inside">
          {items.map((allergen) => (
            <li key={allergen}>{t('label', { allergen: t(`options.${allergen}`) })}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default AllergensList;
